import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CreateCheckoutReminderDtoSchema = z
    .object({
        customMessage: z.string().optional().describe('Custom message for the checkout reminder'),
    })
    .strict();

export class CreateCheckoutReminderDto extends FromSchema(CreateCheckoutReminderDtoSchema) {
    customMessage?: string;
}
